import EnterpriseInfos from "./EnterpriseInfos";

export default EnterpriseInfos;
